module.exports = __webpack_public_path__ + "img/lb-empty-mob.4278b34a.svg";